export const formatIban = (value: string, obfuscate = false) => {
    const val = value && obfuscate ? obfuscateIban(value) : value
    return val
        ? val
              .replace(/[^\da-zA-Z]/g, '')
              .replace(/(.{4})/g, '$1 ')
              .trim()
              .toUpperCase()
        : ''
}

export const currency = (value: number | string, separator = ',', symbol = '€') => {
    const val = stringToNumber(value)
    let returnValue = val.toFixed(2).split('.').join(separator)
    if (symbol) {
        returnValue += ' ' + symbol
    }
    return returnValue
}
export const centToCurrency = (value: number, separator = ',', symbol = '€') => {
    let asString = value.toString()
    if (asString.length <= 2) {
        asString = asString.padStart(3, '0')
    }
    const left = asString.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    let returnValue = left + separator + asString.slice(-2)
    if (symbol) {
        returnValue += ' ' + symbol
    }
    return returnValue
}

export const toCent = (value: string): number => {
    // remove commas, dots and spaces
    const cleaned = value.replace(/[.,\s]/g, '')
    return parseInt(cleaned, 10)
}

export const stringToNumber = (value: number | string): number => {
    let val = value
    if (typeof val === 'string') {
        val = val.replace(',', '.').replace(' ', '')
    }
    let num = parseFloat(val as string)
    if (isNaN(num)) return 0

    return num
}

const obfuscateIban = (value: string) => {
    return value.substring(0, 2) + 'XX XXXX XXXX XXXX XXXX' + value.substring(value.length - 3, value.length)
}
